import { render, staticRenderFns } from "./ProntuarioTab.vue?vue&type=template&id=c16d66fe&scoped=true"
import script from "./ProntuarioTab.vue?vue&type=script&lang=js"
export * from "./ProntuarioTab.vue?vue&type=script&lang=js"
import style0 from "./ProntuarioTab.vue?vue&type=style&index=0&id=c16d66fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16d66fe",
  null
  
)

export default component.exports